import React from 'react'

function Hire() {
    return (
        <div className="hire">
            <div className="project-with">
                <div className="innerpjw-section">
                    <div className="qnstext">
                        <h2>Interested in starting a project with me ?</h2>
                    </div>
                    <div className="gowithus">
                        <button><a href="invalidsb45@gmail.com">Hire me</a></button> 
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Hire
